export const stores = [
    {
        name: "Toko Nusantara",
        position: [-7.408606468853168, 106.98536753654481],
        icon: 'store',
    },
    {
        name: "Toko Nusantara Putra",
        position: [-7.40761701566576, 106.98351144790651],
        icon: 'store',
    },
    {
        name: "Alfamart Bojong Terong",
        position: [-7.4174848498857076, 106.90022349357606],
        icon: 'store',
    },
];